/**
 * Above one inheritable section of the master config, when containers keep
 * their own copy of it: "2 containers have their own Verdicts — TEST 2,
 * TEST 3" and "Override 2" — the master twin of a follower's "Overridden
 * for this container" bar (InheritedSection). Nothing when every
 * container follows.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { PencilLine } from 'lucide-react';
import type { DropGenSection } from '@trafficpulse/shared';

import { SECTION_LABEL } from '../../../../campaign/master/rule-facts';
import { useMasterPush } from '../master-push-context';
import { OverrideButton } from './OwnersTag';

export const OwnersLine: FC<{ section: DropGenSection }> = ({ section }) => {
  const push = useMasterPush();
  const owners = push.owners(section);
  if (!push.active || owners.length === 0) return null;
  const n = owners.length;
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-md border border-dashed border-warning/50 bg-warning/5 px-3 py-1.5 text-[11px] duration-300 animate-in fade-in-0">
      <span className="inline-flex items-center gap-1 font-semibold text-warning">
        <PencilLine className="h-3 w-3" aria-hidden /> {n} container{n === 1 ? ' has its' : 's have their'} own {SECTION_LABEL[section]}
      </span>
      <span className="min-w-0 truncate text-muted-foreground">— {owners.map((o) => o.container.name).join(', ')}</span>
      <span className="ml-auto">
        <OverrideButton section={section} count={n} />
      </span>
    </div>
  );
};
